import React, { useEffect, useState } from 'react'
import { SelectModalPc } from '../Common/SelectModalPc'
import {  ClientResonse, serviceClient } from '../services/common/filter'
import { FilterProps, FilterTypes } from '../../FilterCommon/Filter';
import { isErrorPc } from '@/component/PageComponent/errorPc';
import { count } from 'console';
import { useRequest } from 'ahooks';
import { requestLoading } from '@/hooks/hooksPc/useRequestLoadingPc';
import { SelectModalCommonPc } from '../Common/SelectListModalPc';


export interface FilterClientPcProps  {
  onChange?(value:any,option:any):void
  value:any
}



export function FilterClientPc(props: FilterClientPcProps) {
  const {...rest} = props
  const getList = async (params:any)=>{
    let res =  await serviceClient({ ...params })
    if(isErrorPc(res)){
      return {
        list:[],
        count:0,
      }
    }
    const dataList = res.data?.data?.list || [];
    return {
      list: dataList.map(item => ({...item, label: item.client_name, value: item.client_id})),
      count: res.data.data.count
    }
  }
  let listKey = 'client_id'
  return <SelectModalCommonPc<ClientResonse['data']['list'][0]>
    {...rest} 
    listKey={listKey}
    getList={getList}
    componentKey='FilterClientPc'
    SelectProps={{
      placeholder: '选择客户',
      mode: 'multiple',
    }}
    SelectListModalProps={{
      listKey:listKey,
      getList: getList,
      type:'checkbox',
      title:'选择客户',
      filterProps:{
        filters:[
          { type: FilterTypes.Input, dataIndex: 'kw',placeholder: '名称/手机号/编号',},
          { type: FilterTypes.ClientType, dataIndex: 'type_id',placeholder: '客户类型',mode: undefined},
          { type: FilterTypes.ClientArea, dataIndex: 'area_id',placeholder: '客户地区',multiple: false },
          { type: FilterTypes.AccountStatus, dataIndex: 'status',placeholder: '账号状态', mode: undefined },
        ],
      },
      columns: [
        {
          width: 50,
          dataIndex: 'sequence',
          render: (text: string, record: any, index: number) => {
            return index + 1;
          }
        },
        { width: '15%', title: '客户编号', dataIndex: "client_num" },
        { width: '20%', title: '客户名称', dataIndex: "client_name" }, 
        { width: '20%', title: '客户类型', dataIndex: "type_name" }, 
        { width: '20%', title: '手机号', dataIndex: "mobile" }, 
        { width: '20%', title: '联系人', dataIndex: "contact" }, 
        { width: '20%', title: '地区', dataIndex: "area_name" }, 
      ]
    }}
  />
}

